import React, { useState, useEffect } from "react";
import { DialogMain, IconButtonMain } from "../accounting/styles/DialogStyles";
import { DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  NewUserPopupMain,
  FormMain,
  PermissionsMain,
} from "./styles/NewUserPopupStyle";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../shared/authinput";
import MainButton from "../../shared/Button";
import SelectPermissions from "./SelectPermissions";
import { CustomLabel } from "../../shared/commonstyle/PhoneStyle";
import { CreateAgents, GetPermissions } from "../../../services/admin/agents";
import { toast } from "react-hot-toast";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Password is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must be at least 8 characters long, contain one uppercase letter, one lowercase letter, one digit, and one special character."
    ),
  permissions: Yup.array().min(1, "Select at least one permission"),
});

const NewUserPopup = ({
  open,
  handleClose = () => {},
  setSubmitedValue = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  useEffect(() => {
    if (open) {
      handleFetchAllPermissions();
    }
  }, [open]);

  const handleSubmit = async (values, { resetForm }) => {
    const selectedOptionIds = selectedOptions
      .map((option) => option.value)
      .join(",");
    const DataObj = {
      name: values?.name,
      email: values?.email,
      password: values?.password,
      abilities: selectedOptionIds,
    };
    const res = await CreateAgents(setLoading, DataObj);
    if (res?.status === 200 && res?.data?.message === "Success") {
      resetForm();
      setSelectedOptions([]);
      setSubmitedValue(res?.data?.data);
      handleClose();
      toast.success("Agents Successfully Created!");
    }
  };

  const handleFetchAllPermissions = async () => {
    const resp = await GetPermissions();
    if (resp?.status === 200 && resp?.data?.message === "Success") {
      const formattedOptions = resp?.data?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,
      }));
      setOptions(formattedOptions);
    }
  };

  const PermissionshandleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);

    // Check if "Select All" option is selected

    const selectAllOption = options.find(
      (option) => option.value === "select-all"
    );
    if (selectedOptions?.some((option) => option.value === "select-all")) {
      // Select or deselect all options based on the "Select All" checkbox
      setSelectedOptions(
        selectedOptions.length === options.length ? [] : options
      );
    }
  };

  const selectAllOption = {
    value: "select-all",
    label: "Select All",
  };
  const selectOptions = [selectAllOption, ...options];

  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <NewUserPopupMain>
          <div className="closeBtn">
            <IconButtonMain onClick={handleClose}>
              <CloseIcon />
            </IconButtonMain>
          </div>
          <div className="title">
            <h6>Add New User</h6>
          </div>
        </NewUserPopupMain>
        <DialogContent>
          <FormMain>
            <Formik
              initialValues={{
                name: "",
                password: "",
                email: "",
                permissions: [],
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <Field
                    type="text"
                    name="name"
                    label="Name"
                    component={AuthInput}
                    placeholder="Enter user name"
                  />
                  <Field
                    type="email"
                    name="email"
                    label="Email"
                    component={AuthInput}
                    placeholder="Enter user email address"
                  />
                  <Field
                    type="password"
                    name="password"
                    label="Password"
                    component={AuthInput}
                    placeholder="Enter your password"
                    showIcon={true}
                  />

                  <CustomLabel>Permissions</CustomLabel>
                  <PermissionsMain
                    className={
                      formik.touched.permissions &&
                      formik.errors.permissions &&
                      "haveError"
                    }
                  >
                    <Field name="permissions">
                      {({ field, form }) => (
                        <SelectPermissions
                          options={selectOptions}
                          selectedOption={selectedOptions}
                          handleChange={(selectedOptions) => {
                            formik.setFieldValue(
                              "permissions",
                              selectedOptions
                            );
                            PermissionshandleChange(selectedOptions);
                          }}
                          name="permissions"
                          onBlur={formik.handleBlur}
                        />
                      )}
                    </Field>

                    {formik.touched.permissions &&
                      formik.errors.permissions && (
                        <span className="error">
                          {formik.errors.permissions}
                        </span>
                      )}
                  </PermissionsMain>
                  <MainButton
                    type="submit"
                    label="Add User"
                    isLoading={loading}
                  />
                </Form>
              )}
            </Formik>
          </FormMain>
        </DialogContent>
      </DialogMain>
    </>
  );
};

export default NewUserPopup;
